module.exports = __webpack_public_path__ + "img/profile.94d4503b.jpg";